import { toast } from "sonner";
import { InventoryItem, getMagazijnLabel } from "@/types/inventory";

// Function to copy text to clipboard with feedback
export const copyToClipboard = (text: string, label: string) => {
  navigator.clipboard.writeText(text)
    .then(() => toast.success(`${label} gekopieerd naar klembord`))
    .catch(() => toast.error(`Kon ${label} niet kopiëren`));
};

// Function to copy all product details at once
export const copyAllProductDetails = (item: InventoryItem) => {
  const eenheid = item.eenheid ? ` · ${item.eenheid}` : '';
  const details = [
    `Productnaam: ${item.product_naam}${eenheid}`,
    `Artikelnummer: ${item.product_id}`,
    item.bc ? `Scancode: ${item.bc}` : '',
    item.locatie ? `Locatie: ${item.locatie}` : '',
    `Magazijn: ${getMagazijnLabel(item.magazijn)}`,
    `Voorraad: ${item.voorraad}`,
    `MOQ: ${item.moq || 1}`
  ].filter(Boolean).join('\n');
  
  navigator.clipboard.writeText(details)
    .then(() => toast.success('Alle productgegevens gekopieerd'))
    .catch(() => toast.error('Kon productgegevens niet kopiëren'));
};

// Function to copy basic product information (name, article number, scancode)
export const copyBasicProductDetails = (item: InventoryItem) => {
  const eenheid = item.eenheid ? ` · ${item.eenheid}` : '';
  const details = [
    `Productnaam: ${item.product_naam}${eenheid}`,
    `Artikelnummer: ${item.product_id}`,
    item.bc ? `Scancode: ${item.bc}` : ''
  ].filter(Boolean).join('\n');
  
  navigator.clipboard.writeText(details)
    .then(() => toast.success('Basis productgegevens gekopieerd'))
    .catch(() => toast.error('Kon productgegevens niet kopiëren'));
};

// Re-export this function to keep everything consistent
export { getMagazijnLabel } from "@/types/inventory";
